import { useState, useEffect } from 'react';

interface MediaQueryResult {
  isMobile: boolean;
  width: number;
}

const BREAKPOINT_MOBILE = 768;

export const useMediaQuery = (): MediaQueryResult => {
  // Lazy initializer prevents unnecessary re-render on mount
  const [windowWidth, setWindowWidth] = useState<number>(() => {
    if (typeof window === 'undefined') return BREAKPOINT_MOBILE;
    return window.innerWidth;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // No debounce - React 18+ batches state updates automatically
    // Resize events are already browser-throttled to ~60fps
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isMobile: windowWidth < BREAKPOINT_MOBILE,
    width: windowWidth,
  };
};
